import PersonaPage from "./PersonaPage";
import { questionsPersonFemale } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für die Mutter?",
    a: "Nicht mit einer Aufzählung — mit einem Bild. Der Küchentisch am Sonntag, das Lied, das sie summte, ein Satz, den sie oft sagte. Von dort aus öffnet sich die Rede in warme, ruhige Sätze. Unser Fragebogen führt Sie in acht Schritten dorthin.",
  },
  {
    q: "Was, wenn viel unausgesprochen geblieben ist?",
    a: "Eine Trauerrede darf leise Räume lassen. Was nicht mehr gesagt werden konnte, kann jetzt in einem Satz gewürdigt werden — behutsam, ohne Schuld. Wir helfen, diese Balance zu finden.",
  },
  {
    q: "Wie persönlich darf eine Trauerrede für die Mutter sein?",
    a: "So persönlich, wie es ihr entsprochen hätte. Eine Anekdote, ein Kosename, ein leises Detail — genau das macht den Unterschied zwischen einer Rede und einer Würdigung.",
  },
  {
    q: "Können wir Lieder oder Bibelstellen einbinden?",
    a: "Ja. Sie können im Fragebogen einen Vers, ein Zitat oder einen Liedausschnitt hinterlegen — wir binden ihn behutsam in den Entwurf ein.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für den Vater", to: "/trauerrede-vater" },
  { label: "Trauerrede für die Großmutter", to: "/trauerrede-oma" },
  { label: "Trauerrede für die Schwester", to: "/trauerrede-schwester" },
];

export default function TrauerredeMutter() {
  return (
    <PersonaPage
      slug="trauerrede-mutter"
      metaTitle="Trauerrede für die Mutter schreiben — persönlich & würdevoll | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für die Mutter. Aus Ihren Erinnerungen entsteht in acht behutsamen Fragen ein warmer, würdevoller Entwurf. Sofort verfügbar. Ab 29 €."
      eyebrow="Trauerrede · Mutter"
      headline={
        <>
          Eine Trauerrede für die Mutter.
          <br />
          <span className="italic text-umber">Warm. Genau. In ihrer Stimme.</span>
        </>
      }
      intro="Ein Leben, das andere möglich gemacht hat. Küche, Wäsche, offene Türen, Sätze zwischendurch, die man erst später versteht. Ein behutsamer erster Entwurf — aus acht ruhigen Fragen und Ihren Erinnerungen an sie."
      heroImage="https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=1920&q=80"
      heroImageAlt="Ein Strauß Wiesenblumen auf einem Küchentisch — Sinnbild einer Trauerrede für die Mutter"
      questions={questionsPersonFemale}
      exampleQuote={
        <>
          „Wenn ich an sie denke, denke ich an das Fenster in der Küche. Es war das erste, das
          morgens auf war, und das letzte, das abends schloss. Wer bei ihr am Tisch saß, wusste
          nach fünf Minuten: Hier wird zugehört. Nicht mit Ratschlägen, nicht mit Zeigefinger —
          mit diesem stillen Blick, der sagte: Ich bin hier. Sie war hier. Ein Leben lang.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
